import { atom } from 'jotai'

// ─── Types ────────────────────────────────────────────────────────────────────

export type MainApiKey = 'country' | 'settings' | 'refreshToken'

export interface MainApiLoaded {
    country: boolean // key 1 — country list resolved + countryState set
    settings: boolean // key 2 — FG product catalog + subscription config loaded
    refreshToken: boolean // key 3 — session restored (or confirmed absent)
}

// ─── Atoms ────────────────────────────────────────────────────────────────────

/** All three async gate flags. Write via setApiLoadedAtom. */
export const mainApiLoadedAtom = atom<MainApiLoaded>({
    country: false,
    settings: false,
    refreshToken: false
})

/**
 * Derived 0-100 progress value.
 * Reactive — LoadingBar reads this directly.
 */
export const loadingPercentAtom = atom<number>(get => {
    const loaded = get(mainApiLoadedAtom)
    const total = Object.keys(loaded).length
    const trueCount = Object.values(loaded).filter(Boolean).length
    return (trueCount / total) * 100
})

/**
 * Flipped to true 1 second after all 3 keys are true.
 * Managed by LoadingBar itself via useEffect.
 */
export const isWebReadyAtom = atom<boolean>(false)

/**
 * Write-only helper atom — sets a single key without touching the others.
 *
 * Usage:
 *   const setApiLoaded = useSetAtom(setApiLoadedAtom)
 *   setApiLoaded({ key: 'country', value: true })
 */
export const setApiLoadedAtom = atom(null, (get, set, { key, value }: { key: MainApiKey; value: boolean }) => {
    set(mainApiLoadedAtom, { ...get(mainApiLoadedAtom), [key]: value })
})
